<div class="btn-group w-100" role="group">
    <div ngbDropdown class="w-100" display="dynamic">
        <button
            ngbDropdownToggle
            id="businessVenueSelection"
            class="btn d-flex align-items-center text-start w-100"
            [ngClass]="compact ? 'compact px-2' : ''"
            type="button"
        >
            <div
                class="location"
                [ngClass]="compact ? 'me-2 me-lg-0' : 'me-2'"
            >
            </div>
            <span
                *ngIf="!compact"
                class="text-truncate"
            >
                {{ dropdownTitle$ | async }}
            </span>
            <span
                *ngIf="compact"
                class="text-truncate d-lg-none"
            >
                {{ dropdownTitle$ | async }}
            </span>
        </button>
        <div
            ngbDropdownMenu
            aria-labelledby="businessVenueSelection"
            class="position-fixed"
            style="max-height: 400px; overflow-y: auto; min-width: 220px; max-width: 400px;"
        >
            <ng-container *ngIf="businesses$ | async as businesses">
                <div class="vstack gap-2 p-1">
                    <ng-container *ngFor="let business of businesses; let isFirst = first; let isLast = last">
                        <div class="vstack gap-2">
                            <span 
                                class="ms-2 fw-semibold m-0 d-flex align-items-center fs-5 text-truncate"
                                [class.pt-2]="!isFirst"
                            >
                                {{ business.displayName }}
                          </span>
                            
                            <ng-container *ngIf="getBusinessVenues(business) | async as venues">
                                <ng-container *ngIf="venues.length > 0; else noVenues">
                                    <div class="vstack">
                                        <button
                                            *ngFor="let venue of venues"
                                            class="dropdown-item text-start py-2 px-3 rounded"
                                            (click)="selectBusinessAndVenue(business, venue)"
                                        >
                                            <div class="hstack gap-3">
                                                <span class="flex-grow-1 text-truncate">{{ venue.displayName }}</span>
                                                <div class="ms-auto">
                                                    <i
                                                        *ngIf="isSelected(business, venue)"
                                                        class="bi bi-check-circle-fill text-primary fs-5"
                                                    ></i>
                                                    <i
                                                        *ngIf="!isSelected(business, venue)"
                                                        class="bi bi-circle text-body-secondary"
                                                    ></i>
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                </ng-container>
                                <ng-template #noVenues>
                                    <div class="dropdown-item-text px-3 text-body-secondary text-center">
                                        No venues available
                                    </div>
                                </ng-template>
                            </ng-container>
                        </div>
                        
                        <hr *ngIf="!isLast" class="my-1 border-muted-subtle" />
                    </ng-container>
                    
                    <ng-container *ngIf="businesses.length === 0">
                        <div class="dropdown-item-text text-body-secondary text-center py-3">
                            No businesses available
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</div>
